import React, { Component } from "react";
import Head from 'next/head'
import ErrorPage from 'next/error'
import Books from './books.json'
import BookThumb from './bookthumb'
import { getUId, getBBGRating, getDate } from './bbgcommon'
import './book.css'

import './bookeffect.css'

export default class extends Component {
    
    constructor(props){
        super(props);

        var index = -1;
        var book = Books.find(function (b, i) { 
            if(getUId(b) == props.query.bookid){
                index = i;
                return true;               
            } 
        });

        this.state = { 
            bookid : props.query.bookid,
            book: book,
            index: index,
            previousBook: ((index > 0)?Books[index-1]:null),
            nextBook: ((index < Books.length)?Books[index+1]:null),
        };
    }
    
    render(){
        return <div>
            {this.state.book?
            <div className="BookItem-Detail">
                <Head>
                    <title>{this.state.book.Title} ({getDate(this.state.book)}) by {this.state.book.Author} - Business Books Guide</title>  
                    <meta http-equiv="content-language" content="en-us"/>
                    <meta name="description" content=""/>
                </Head>

                <figure class='book'> 

                    <ul class='hardcover_front'>
                        <li>
                            <img src={`http://images.amazon.com/images/P/`+getUId(this.state.book)+`.01._SCMZZZZZZZ_.jpg`} alt="" width="100%" height="100%"/>
                        </li>
                        <li></li>
                    </ul>   
                    <ul class='page'>
                        <li></li>
                        <li>
                            <a class="btn" href="#">Mark as read</a>
                        </li>
                        <li></li>
                    </ul>   
                    
                    <figcaption>
                    <div className="BookItem-Detail-Sequence">{this.state.index+1}</div>
                    <div className="BookItem-Detail-Rating">{getBBGRating(this.state.book)}</div>
                        <h1 className="BookItem-Detail-Title">{this.state.book.Title}</h1>
                        <div>by {this.state.book.Author}</div>
                        <div>
                            <p>Category: {this.state.book.Type}</p>
                            <p>Publication date: {getDate(this.state.book)}  </p>       
                            <p>ASIN: {this.state.book.ASIN}</p>
                            <p>ISBN: {this.state.book.ISBN}</p>
                            <p><a href={`http://www.amazon.com/dp/`+getUId(this.state.book)+`/?tag=cloudby901-20`}>Amazon</a></p>
                        </div>
                    </figcaption>     
                </figure>
                
            </div>:<ErrorPage statusCode={404} />}
            <div className="BookItem-Detail-Footer">
                {this.state.previousBook&&<div>
                    <BookThumb book={this.state.previousBook}/>
                </div>}
                {this.state.previousBook&&this.state.nextBook&&<div className="BookItem-Detail-Separator">
                </div>}
                {this.state.nextBook&&<div>
                    <BookThumb book={this.state.nextBook}/>
                </div>}
            </div>
        </div>;
    }
}